export default "__VITE_ASSET__BwL2DQqf__"